<template>
  <div class="col-12">
    <transition mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: "CDLConsultor",
  data() {
    return {
      produto: [
        {
          nome: "CDL Consultor",
          id: "CdlConsultor",
        },
      ],
    };
  },
  methods: {},
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    if (this.$router.currentRoute.path === "/produto/cdl-consultor") {
      this.$router.push({ name: "gerenciarAssociados" });
    }
  },
};
</script>
